/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Studies {
    HIGH_EDUCATION = 'highEducation',
    PRIMARY_EDUCATION = 'primaryEducation',
    MEDIUM_EDUCATION = 'mediumEducation',
    NO_EDUCATION = 'noEducation',
}
